import { render } from "./Collaborators.vue?vue&type=template&id=dd0cc11a&scoped=true"
import script from "./Collaborators.vue?vue&type=script&lang=js"
export * from "./Collaborators.vue?vue&type=script&lang=js"

import "./Collaborators.vue?vue&type=style&index=0&id=dd0cc11a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd0cc11a"]])

export default __exports__